export default {
  adminRootPath: () => "/admin",
};
